import styled from 'styled-components';

export const BadgeContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 4px;
  padding: 2px 8px;
  border-radius: 24px;
  width: max-content;

  color: ${props => props.color || '#fff'};
  font-size: 0.65rem;
  font-weight: 500;

  background-color: ${props => props.backgroundColor || 'rgba(255, 255, 255, 0.1)'};
  border: 1px solid ${props => props.color || '#fff'};
`;
